import { render, staticRenderFns } from "./CourseLanding.vue?vue&type=template&id=525218eb&scoped=true"
import script from "./CourseLanding.vue?vue&type=script&lang=js"
export * from "./CourseLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525218eb",
  null
  
)

export default component.exports